/**
 * Formatters for the teacher pay surface (BON-247), shared by TeacherPay and
 * its row/table/group components.
 */
import { formatVenueDate } from '../../../utils/venueTime';

import type { PayShiftEntry } from './teacherApi';

export const EM_DASH = '—';

/** Cents → "$250.00". */
export function formatCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

/**
 * "12 Mar 2026" for a PAY-CALENDAR date — `payDateIso`/`coversFromIso`/
 * `coversToIso`, admin-configured calendar dates (`YYYY-MM-DD`). Formatted in
 * UTC because these are pure date-only values, NOT workshop times; a shift's
 * own date takes the venue-local path in `formatShiftDate`.
 */
export function formatPayDate(iso: string): string {
  return new Intl.DateTimeFormat('en-GB', {
    // eslint-disable-next-line no-restricted-syntax -- pay-calendar date-only value, not a workshop time
    timeZone: 'UTC',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(iso.length === 10 ? `${iso}T00:00:00.000Z` : iso));
}

/**
 * A shift's date from its VENUE-LOCAL wall clock (BON-386) — a date-only render
 * off the absolute instant shows the wrong day for evening workshops in western
 * zones (and the wrong pay period). Falls back to the instant when unset.
 */
export function formatShiftDate(shift: PayShiftEntry): string {
  return shift.localStartsAtIso
    ? formatVenueDate(shift.localStartsAtIso, 'd MMM yyyy')
    : formatPayDate(shift.startsAtIso);
}
